"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronizedXHRRequestsBlocker = void 0;
class SynchronizedXHRRequestsBlocker {
    constructor(xhrRequestsBlocker, informant) {
        this.name = this.constructor.name;
        this.xhrRequestsBlocker = xhrRequestsBlocker;
        this.informant = informant;
    }
    startBlockingRequests() {
        this.xhrRequestsBlocker.startBlockingRequests();
        this.informant.startBlockingRequests();
    }
    finishBlockingRequest() {
        this.xhrRequestsBlocker.finishBlockingRequest();
        this.informant.finishBlockingRequest();
    }
    isBlockingRequest() {
        return this.xhrRequestsBlocker.isBlockingRequest();
    }
    getBlocker() {
        return this.xhrRequestsBlocker.getBlocker();
    }
}
exports.SynchronizedXHRRequestsBlocker = SynchronizedXHRRequestsBlocker;
//# sourceMappingURL=synchXhrBlockRequest.js.map